import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/** From a given string and a search text, surrounds the searched text in a bold `<span>` element.
 *  The span's inner style attribute can be overridden to support other styles. */
@Pipe({
  name: 'embolden'
})
export class EmboldenPipe implements PipeTransform {

  constructor(readonly san: DomSanitizer) { }

  transform(text: string, search: string, truncateAfter: number = 0, overrideSpanStyle: string = null): SafeHtml {
    if (!text || text === '' || !search || search === '' || text.startsWith('...')) {
      return text;
    }
    let regexPattern = search.toString().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    regexPattern = regexPattern.split(' ').filter((t) => t.length).join('|');
    const regex = new RegExp(regexPattern, 'gi');
    if (truncateAfter > 0) {
      if (truncateAfter < search.length) {
        truncateAfter = search.length + 1;
      }
      const textPlacement = text.toLowerCase().lastIndexOf(search);
      const x = textPlacement - truncateAfter;
      let preText = text.substring((x > 0) ? x : 0, textPlacement);
      let postText = text.substr(textPlacement, truncateAfter);
      if (textPlacement + search.length > truncateAfter) {
        postText += '...';
      }
      if (textPlacement !== 0) {
        preText = '...' + preText;
      }
      // if (pretext.length > truncateAfter) { pretext = '...' + pretext.substr(0, truncateAfter); }
      text = preText + postText;
    }
    const emboldened = search ? text.replace(regex, (match) => `<span ${overrideSpanStyle
      ? overrideSpanStyle
      : 'style="font-weight: bold;"'}>${match}</span>`) : text;

    return this.san.bypassSecurityTrustHtml(emboldened);
  }
}
